import summitImage2 from "../../assets/News and Events/TPRM event summit/869A3290.JPG";
import summitImage3 from "../../assets/News and Events/TPRM event summit/869A3042.JPG";
import eventImageMain from "../../assets/News and Events/TPRM event summit/869A2837.JPG";
import detailImage from "../../assets/News and Events/TPRM event summit/869A3079.JPG";
import aiplanetLogo from "../../assets/images/ConsortiumPartners/aiplanetlogo.svg";
import aiplanetImage1 from "../../assets/News and Events/AIPlanet/image-1.jpg";
import aiplanetImage2 from "../../assets/News and Events/AIPlanet/image-2.webp";
import riyadhOfficeImage from "../../assets/News and Events/Riyadh office/office.avif";

const newsEntries = [
  {
    id: "riyadh-office-launch",
    slug: "riyadh-office-launch",
    title: "Vardaan Global Expands Presence with New Office in Riyadh",
    date: "July 13, 2025",
    readTime: "3 min read",
    category: "Company News",
    mediaFit: "cover",
    summary:
      "Vardaan Global strengthens its Middle East footprint with the official launch of its new office in Riyadh, Saudi Arabia, marking a significant milestone in the company's global expansion strategy.",
    image: riyadhOfficeImage,
    tag: "Company News",
    content: [
      "Vardaan is happy to announce that we have opened our office at Virtual Technologies in Riyadh, Saudi Arabia, on July 13, 2025. The new office is located at Building no. 8703, Al Arz Street, Olaya District, Riyadh, Kingdom of Saudi Arabia, 12611. This strategic expansion reinforces our commitment to serving clients across the Middle East region and reflects our growing presence in key global markets. The new facility positions us to better serve enterprises and government entities in the region with our comprehensive suite of risk management, compliance, and AI-driven solutions.",
      "The Riyadh office represents a significant milestone in Vardaan's global expansion journey, complementing our existing presence across India, Malaysia, UAE, UK, USA, and Egypt. This expansion enables us to provide enhanced local support, deeper market understanding, and stronger partnerships with regional organizations seeking to transform their governance, risk, and compliance capabilities through innovative technology solutions.",
      "As we continue to expand our global footprint, this new office will serve as a hub for client engagement, regional collaboration, and talent development in the Middle East. The strategic location in Riyadh's thriving business district aligns with our vision of delivering world-class solutions while building lasting relationships with organizations across diverse industries and sectors."
    ],
    gallery: [riyadhOfficeImage],
    quotes: [
      "“This expansion reflects our commitment to bringing world-class risk and compliance solutions closer to our clients in the Middle East.”"
    ]
  },
  {
    id: "leadership-event",
    slug: "leadership-event",
    title: "Leadership Summit: Team Vardaan Takes the Stage",
    date: "November 10, 2025",
    readTime: "5 min read",
    category: "Events",
    mediaFit: "cover",
    summary:
      "Vardaan Data Sciences participated as an Exhibit Partner at the 10th Third Party Risk Management India Summit 2025, showcasing how RiskaVaire TPRM and RiskaVaire GRC close critical governance gaps.",
    image: eventImageMain,
    tag: "Events",
    content: [
      "Vardaan Data Sciences Pvt. Ltd. participated as an Exhibit Partner at the 10th Third Party Risk Management India Summit 2025, hosted by Inventicon Business Intelligence Pvt. Ltd. Our team showcased our flagship platforms, RiskaVaire TPRM and RiskaVaire GRC, highlighting how they bridge existing gaps in third-party risk, regulatory compliance, and enterprise governance.",
      "Across the two-day summit, we engaged with leaders, practitioners, and experts from some of the largest organizations, discussing real-world challenges in vendor risk, continuous monitoring, and regulatory expectations. These discussions gave us the opportunity to demonstrate how our AI-enabled solutions deliver unified risk scoring, streamlined assessments, and practical, action-oriented insights.",
      "The event also offered deep exposure to emerging trends in TPRM and GRC, helping us refine and validate our product roadmap for RiskaVaire. Overall, this summit marked an important milestone in Vardaan’s journey to build practical, intelligent, and future-ready risk and compliance systems for modern enterprises."
    ],
    gallery: [detailImage, summitImage2, summitImage3],
    quotes: [
      "“Each conversation added clarity, depth, and direction to how we are shaping RiskaVaire.”",
      "“AI-enabled insights are finally making continuous vendor monitoring practical.”"
    ]
  },
  {
    id: "aiplanet-partner",
    slug: "aiplanet-partner",
    title: "AI Planet and InfoDrive Launch UAE AI Hub",
    date: "October 17, 2025",
    readTime: "2 min read",
    category: "Partnerships",
    mediaFit: "contain",
    summary:
      "AI Planet and InfoDrive Analytics launch a $3M venture in Dubai to build a regional AI and digital transformation hub for governments and enterprises.",
    image: aiplanetLogo,
    tag: "Partnerships",
    content: [
      "Signed at GITEX Global with Belgium’s ambassador present, the venture marks AI Planet’s first UAE footprint, complementing its teams in Belgium, Luxembourg, and India.",
      "InfoDrive Analytics backs the regional hub with $3 million aimed at market development, customer acquisition, operations, and local AI talent, while positioning AI Planet’s GenAI platform for adoption.",
      "The partnership will deliver government and enterprise-ready Generative and Agentic AI solutions plus industry vertical plays across finance, manufacturing, healthcare, telecom, and education."
    ],
    gallery: [aiplanetImage1, aiplanetImage2],
    quotes: [
      "“The partnership blends AI Planet’s orchestration expertise with InfoDrive’s regional reach to empower governments and enterprises.”"
    ]
  }
];

export default newsEntries;

